"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
// import { get_data_from_db } from '../api'
var styled_components_1 = __importDefault(require("styled-components"));
// import { Search } from './Search'
// import { Log } from './Daily_Log'
var Home_1 = require("./Home");
var Food_1 = require("./Food");
var Top_Nav_1 = __importDefault(require("./Top_Nav"));
var Register_1 = require("./Register");
var Login_1 = require("./Login");
var api_1 = require("../api");
var react_redux_1 = require("react-redux");
var Weekly_Chart_1 = require("./Weekly_Chart");
function App() {
    var logged_in = (0, react_redux_1.useSelector)(function (state) { return state.default.logged_in; });
    (0, react_1.useEffect)(function () {
        var token = (0, api_1.check_for_token)();
        if (token) {
            (0, api_1.validate_token)(token);
        }
        else {
            console.log("NO TOKEN STORED");
        }
        // get_data_from_db();
    }, [logged_in]);
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(react_router_dom_1.HashRouter, null,
            react_1.default.createElement(Top_Nav_1.default, null),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/", exact: true, component: Home_1.Home }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/food", component: Food_1.Food }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/register", component: Register_1.Register }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/login", component: Login_1.Login }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/weekly_chart", component: Weekly_Chart_1.Weekly_Chart })))));
}
exports.App = App;
var Wrapper = styled_components_1.default.div.withConfig({ displayName: "App.tsx-Wrapper", componentId: "-1778kzz" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background: ", ";\n    height: 100%;\n    overflow-y: auto;\n"], ["\n    color: ", ";\n    background: ", ";\n    height: 100%;\n    overflow-y: auto;\n"])), function (props) { return props.theme.color; }, function (props) { return props.theme.background; });
var templateObject_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQXBwLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBd0M7QUFDeEMscURBSzRCO0FBQzVCLDRDQUE0QztBQUM1Qyx3RUFBc0M7QUFDdEMsb0NBQW9DO0FBQ3BDLG9DQUFvQztBQUNwQywrQkFBNkI7QUFDN0IsK0JBQTZCO0FBQzdCLHNEQUErQjtBQUMvQix1Q0FBcUM7QUFDckMsaUNBQStCO0FBQy9CLDhCQUF3RDtBQUN4RCwyQ0FBMEM7QUFFMUMsK0NBQThDO0FBSTlDLFNBQWdCLEdBQUc7SUFFZixJQUFNLFNBQVMsR0FBRyxJQUFBLHlCQUFXLEVBQUMsVUFBQyxLQUFnQixJQUFLLE9BQUEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxTQUFTLEVBQXZCLENBQXVCLENBQUMsQ0FBQztJQUU3RSxJQUFBLGlCQUFTLEVBQUM7UUFDTixJQUFNLEtBQUssR0FBRyxJQUFBLHFCQUFlLEdBQUUsQ0FBQztRQUNoQyxJQUFJLEtBQUssRUFBRTtZQUNQLElBQUEsb0JBQWMsRUFBQyxLQUFLLENBQUMsQ0FBQztTQUN6QjthQUFNO1lBQ0gsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQkFBaUIsQ0FBQyxDQUFDO1NBQ2xDO1FBQ0Qsc0JBQXNCO0lBQzFCLENBQUMsRUFBRSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUE7SUFFZixPQUFPLENBQ0gsOEJBQUMsT0FBTztRQUNKLDhCQUFDLDZCQUFNO1lBQ0gsOEJBQUMsaUJBQU8sT0FBRztZQUNYLDhCQUFDLHlCQUFNO2dCQUNILDhCQUFDLHdCQUFLLElBQUMsSUFBSSxFQUFDLEdBQUcsRUFBQyxLQUFLLFFBQUMsU0FBUyxFQUFFLFdBQUksR0FBSTtnQkFDekMsOEJBQUMsd0JBQUssSUFBQyxJQUFJLEVBQUMsT0FBTyxFQUFDLFNBQVMsRUFBRSxXQUFJLEdBQUk7Z0JBQ3ZDLDhCQUFDLHdCQUFLLElBQUMsSUFBSSxFQUFDLFdBQVcsRUFBQyxTQUFTLEVBQUUsbUJBQVEsR0FBSTtnQkFDL0MsOEJBQUMsd0JBQUssSUFBQyxJQUFJLEVBQUMsUUFBUSxFQUFDLFNBQVMsRUFBRSxhQUFLLEdBQUk7Z0JBQ3pDLDhCQUFDLHdCQUFLLElBQUMsSUFBSSxFQUFDLGVBQWUsRUFBQyxTQUFTLEVBQUUsMkJBQVksR0FBSSxDQUVsRCxDQUNKLENBQ0gsQ0FDYixDQUFBO0FBQ0wsQ0FBQztBQTdCRCxrQkE2QkM7QUFFRCxJQUFNLE9BQU8sR0FBRywyQkFBTSxDQUFDLEdBQUcsa09BQUEsZUFDYixFQUEwQixxQkFDckIsRUFBK0IsK0NBR2hELEtBSlksVUFBQSxLQUFLLElBQUksT0FBQSxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUssRUFBakIsQ0FBaUIsRUFDckIsVUFBQSxLQUFLLElBQUksT0FBQSxLQUFLLENBQUMsS0FBSyxDQUFDLFVBQVUsRUFBdEIsQ0FBc0IsQ0FHaEQsQ0FBQSJ9